import styled from 'styled-components';

import { keyFrameExampleOne } from './KeyFrames';


export default styled.div`
	min-width: 1rem;
	position: relative;
	opacity: 1;
	transform-origin: center;
  
  ${ props => props.notFullHeight ? 'height: 100%;' : ''}
  svg:not(:root) {
	overflow: visible;
}
	svg {
		animation: ${keyFrameExampleOne} 2s linear 0s infinite;
		width: 100%;
	 	height: 100%;
		max-height: 10rem;
		fill: rgba(211, 204, 255, 1);
	}
	span.isvg {
		width: 100%;
    height: 100%;
	}


	${props => props.thisStylesIcon}
`;
